import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import Form from "../../components/forms/ConfirmForm";
import {cancelMarkShipmentAsComplimentary} from "../../actions/ShippingApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class MarkShipmentAsComplimentaryFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = {
      orderId: this.props.orderId
    }
    return this.props.markShipmentAsComplimentary(updatedValues)
      .then((response) => {
        if (response.data.markShipmentAsComplimentary.errors.length <= 0) {
          this.props.cancelMarkShipmentAsComplimentary();
        } else {
          let errors = createValidationErrors(response.data.markShipmentAsComplimentary.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleUndoSubmit(values) {
    let updatedValues = {
      orderId: this.props.orderId
    }
    return this.props.unmarkShipmentAsComplimentary(updatedValues)
      .then((response) => {
        if (response.data.unmarkShipmentAsComplimentary.errors.length <= 0) {
          this.props.cancelMarkShipmentAsComplimentary();
        } else {
          let errors = createValidationErrors(response.data.unmarkShipmentAsComplimentary.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });          
  }

  handleCancel() {
    this.props.cancelMarkShipmentAsComplimentary();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />  

    if (data.shippingOrder.type === "complimentary") {
      return (
        <Form
          key="complimentary"
          errors={this.state.errors}
          message="This order is already marked as complimentary, do you wish to undo this action?"
          submitLabel="Undo"
          onSubmit={this.handleUndoSubmit.bind(this)}
          onCancel={this.handleCancel.bind(this)}
          />
      )
    }
    return (
      <Form
        key="normal"
        errors={this.state.errors}
        message="By marking this shipment as complimentary, the specified email address will recieve an email with tracking information, and a note that this order is complimentary."
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const MARK_AS_COMPLIMENTARY = gql`
  mutation markShipmentAsComplimentary($data: ShippingIdInput!) {
    markShipmentAsComplimentary(input: $data) {
      errors { key message }
    }
  }
`;

const UNMARK_AS_COMPLIMENTARY = gql`
  mutation unmarkShipmentAsComplimentary($data: ShippingIdInput!) {
    unmarkShipmentAsComplimentary(input: $data) {
      errors { key message }
    }
  }
`;

const GET_ORDER_TYPE = gql`
  query shippingOrder($orderId: ID!) {
    shippingOrder(orderId: $orderId) {
      orderId
      type
    }
  }
`

const withQueries = compose(
  graphql(GET_ORDER_TYPE, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        orderId: props.orderId
      }
    })
  }),
  graphql(MARK_AS_COMPLIMENTARY, {
    props: ({ mutate }) => ({
      markShipmentAsComplimentary: (data) => mutate({
        variables: { data: data }
      })
    })
  }),
  graphql(UNMARK_AS_COMPLIMENTARY, {
    props: ({ mutate }) => ({
      unmarkShipmentAsComplimentary: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelMarkShipmentAsComplimentary})(withQueries(MarkShipmentAsComplimentaryFormContainer));